import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "LandingPageContact" })
export default class LandingPageContact extends Vue {
    public validationErrors: any[] = [];
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {
        dealerPointCode: null,
        zone: null
    };
    public dealerPointZone: string = null;
    public dealerPoints: any[] = [];
    public zones: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly slug: string;
    @Prop() readonly marketType: string;
    @Prop() readonly formTitle: string;
    @Prop() readonly isNotesField: boolean;
    @Prop() readonly isDealerPointSelector: boolean;
    @Prop() readonly isAddressFields: boolean;
    @Prop() readonly isVehicleFields: boolean;
    @Prop() readonly isVinField: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        if (this.isDealerPointSelector || this.isAddressFields) {
            await this.getZones();
        }
    }

    public async getDealerPoints() {
        if (this.dealerPointZone) {
            this.dealerPoints = (await Axios.post(this.routes.LandingPage_GetDealerPoints, { province: this.dealerPointZone, dealerMarket: this.marketType })).data;
        } else {
            this.dealerPoints = [];
        }
    }

    public async getZones() {
        this.zones = (await Axios.post(this.routes.LandingPage_GetZones)).data;
    }

    public async setDealerData() {
        if (this.formData.dealerPointCode) {
            this.formData.dealerCode = this.dealerPoints.find(x => x.code == this.formData.dealerPointCode).dealerCode;
        } else {
            this.formData.dealerCode = null;
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        (<any>window).grecaptcha.enterprise.ready(async () => {
            const token = await (<any>window).grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'Submit' });

            try {
                await Axios.post(this.routes.LandingPage_SetContact + "?slug=" + this.slug, this.formData, { headers: { "RecaptchaVerificationToken": token } });
                this.isSuccess = true;
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }

            this.isLoadingForm = false;
        });
    }

    public profiling(profiling: boolean) {
        this.formData.isProfiling = profiling;
    }

    public marketing(marketing: boolean) {
        this.formData.isMarketing = marketing;
    }

    public marketingChannels(marketingChannels: any) {
        this.formData.marketingChannels = marketingChannels;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};